import { render, staticRenderFns } from "./AppRegistrationEmail.vue?vue&type=template&id=537b1a4a&"
import script from "./AppRegistrationEmail.vue?vue&type=script&lang=js&"
export * from "./AppRegistrationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports